import { render } from "./basicScene.vue?vue&type=template&id=a1a47fe6&scoped=true"
import script from "./basicScene.vue?vue&type=script&lang=js"
export * from "./basicScene.vue?vue&type=script&lang=js"

import "./basicScene.vue?vue&type=style&index=0&id=a1a47fe6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1a47fe6"]])

export default __exports__